import React, {
  useRef,
  useContext,
}                             from 'react';
import { useTranslation}      from 'react-i18next';
import PlanBillingContext     from './context';
import ReceiptIcon            from '@material-ui/icons/Receipt';
import List                   from '~/containers/List';
import { showPlanBilling }    from '~/config/routes';
import Request                from '~/providers/Request';
import csvGenerator           from '~/utils/csvGenerator';
import { toast }              from 'react-toastify';
import moment                 from 'moment';
import { AbilityContext }     from '~/contexts/Can';

function PlanBillingsList() {
  const { t } = useTranslation();
  const trAttr = (attr) => t(`planBilling.attributes.${attr}`);
  const listEl = useRef(null);
  const ability = useContext(AbilityContext);

  function generateCSV() {
    toast.info('Arquivo CSV esta sendo gerado!');

    const params = function() {
      const vars = {};
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
          vars[key] = value;
      });

      return vars;
    };

    Request.get('/admin/plan_billings/', { ...params(), csv: true })
      .then(response => {
        const dateFormat = date => date && moment(date).format('DD/MM/YYYY HH:mm:ss');
        const headers = ['ID', 'Usuário', 'Plano', 'Data da Transação', 'Data de Validade', 'ID Transação'];
        const rows = response.data.map(pack_bill => {
          const transactionAt = dateFormat(pack_bill.transaction_at);
          const validityAt = dateFormat(pack_bill.validity_at);

          return [
            pack_bill.id, pack_bill.user_name, pack_bill.plan_name, transactionAt, validityAt,
            pack_bill.transaction_id
          ];
        });

        csvGenerator('compras-de-assinaturas.csv', [headers, ...rows]);

        toast.success('Arquivo CSV gerado com sucesso!');
      })
      .catch(err => {
        toast.error('Não foi possível gerar o arquivo CSV');
        console.error('[ERROR to generateCSV]', err);
      });
  }

  const actions = [
    'search',
    'filter',
    'export',
  ];

  if(ability.can('show', 'PlanBillings')) {
    actions.push('show');
  }

  return (
    <>
      <List
        routeToShow={showPlanBilling}
        listEl={listEl}
        path={'/admin/plan_billings/'}
        actions={actions}
        onExport={generateCSV}
        paperProps={{
          Icon:ReceiptIcon,
          iconColor:'green',
          title: t('planBilling.defPlural'),
        }}
        columns={[
          { title: trAttr('user_id'), field: 'user_id', type: 'numeric', hidden: true},
          { title: trAttr('user_name'), field: 'user_name', type: 'string'},
          { title: trAttr('plan_name'), field: 'plan_name', type: 'string'},
          { title: trAttr('transaction_at'), field: 'transaction_at', type: 'datetime'},
          { title: trAttr('validity_at'), field: 'validity_at', type: 'datetime'},
          { title: trAttr('price'), field: 'price', type: 'currency', hidden: true},
          { title: trAttr('transaction_id'), field: 'transaction_id', type: 'string', hidden: true},
          { title: trAttr('store'), field: 'store', type: 'string', hidden: true},
          { title: trAttr('state'), field: 'state', type: 'string', hidden: true}
        ]}
        context={PlanBillingContext}
        recordMap={
          record => ({
            ...record,
            transaction_at: record.transaction_at ? moment(record.transaction_at).format('DD/MM/YYYY HH:mm') : null,
            validity_at: record.validity_at ? moment(record.validity_at).format('DD/MM/YYYY HH:mm') : null
          })
        }
      />
    </>
  );
}

export default React.memo(PlanBillingsList);
